import Swal from "sweetalert2";
import { DeploymentTransferCredentials } from "../../api/deployments";
import { getSshCredentialStatus } from "../../api/sshConnection";
import { Site } from "../../api/sites";

const hasStoredPassword = async (site: Site): Promise<boolean> => {
    if (site.sshProfileId == null) return site.hasStoredSshPassword === true;
    try {
        return (await getSshCredentialStatus(site.sshProfileId)).hasStoredPassword;
    } catch (error) {
        console.error("SSH credential status load failed", error);
        return site.hasStoredSshPassword === true;
    }
};

export const requestTransferCredentials = async (
    site: Site
): Promise<DeploymentTransferCredentials | null> => {
    if (!site.sshHost?.trim() || !site.sshUsername?.trim()) {
        await Swal.fire({
            icon: "warning",
            title: "SSH 설정이 필요합니다.",
            text: "경로 관리에서 SSH 호스트와 계정을 먼저 등록해 주세요.",
        });
        return null;
    }

    if (site.sshAuthType === "PRIVATE_KEY") {
        if (!site.sshPrivateKeyPath?.trim()) {
            await Swal.fire({
                icon: "warning",
                title: "개인키 경로가 필요합니다.",
                text: "경로 관리에서 SSH 개인키 경로를 등록해 주세요.",
            });
            return null;
        }

        const result = await Swal.fire({
            title: "SSH 개인키 암호",
            text: "개인키에 암호가 없으면 비워둔 채 계속 진행하세요.",
            input: "password",
            inputAttributes: {
                autocomplete: "off",
            },
            showCancelButton: true,
            confirmButtonText: "계속",
            cancelButtonText: "취소",
        });
        if (!result.isConfirmed) return null;
        return {
            privateKeyPassphrase: String(result.value ?? ""),
        };
    }

    if (await hasStoredPassword(site)) {
        return {};
    }

    const result = await Swal.fire({
        title: "SSH 비밀번호",
        input: "password",
        inputAttributes: {
            autocomplete: "off",
        },
        inputValidator: (value) => (!value ? "비밀번호를 입력해 주세요." : undefined),
        showCancelButton: true,
        confirmButtonText: "계속",
        cancelButtonText: "취소",
    });
    if (!result.isConfirmed) return null;
    return {
        password: String(result.value),
    };
};
